import Message from '@admin/components/message'
import Loader from '@admin/components/loader'
import PropTypes from 'prop-types'
import React from 'react'

class Authorized extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    host: PropTypes.object,
    network: PropTypes.object
  }

  static propTypes = {
    children: PropTypes.any,
    image: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string,
    profile: PropTypes.object,
    service: PropTypes.string,
    status: PropTypes.string,
    type: PropTypes.string,
    onAuthorized: PropTypes.func,
    onProfile: PropTypes.func
  }

  static defaultProps = {
    onProfile: () => {}
  }

  _handleAuthorized = this._handleAuthorized.bind(this)

  render() {
    const { children, profile, status } = this.props
    if(status === 'loading') return <Loader />
    if(profile === null) return <Message { ...this._getMessage() } key="message" />
    return children
  }

  componentDidMount() {
    this._handleJoin()
  }

  componentDidUpdate(prevProps) {
    const { profile } = this.props
    if(profile !== prevProps.profile) {
      this.props.onProfile(profile)
    }
  }

  componentWillUnmount() {
    this._handleLeave()
  }

  _getMessage() {
    const { image, icon, label , service, type } = this.props
    const { token } = this.context.admin.team
    return {
      image,
      icon,
      title: label,
      text: `t(In order to access ${label}, you must authorize Maha to access your account)`,
      button: {
        label: 't(Authorize)',
        link: `${process.env.ADMIN_HOST}/admin/oauth/${service}/authorize?type=${type}&token=${token}`
      }
    }
  }

  _handleAuthorized({ profile }) {
    this.props.onAuthorized(profile)
  }

  _handleJoin() {
    const { admin } = this.context
    const { account } = admin
    const { service } = this.props
    this.context.network.subscribe({ 
      channel: `/accounts/${account.id}/admin/sources/${service}/authorized`,
      action: 'authorized', 
      handler: this._handleFetch 
    })
  }

  _handleLeave() {
    const { admin } = this.context
    const { account } = admin
    const { service } = this.props
    this.context.network.unsubscribe({ 
      channel: `/accounts/${account.id}/admin/sources/${service}/authorized`,
      action: 'authorized', 
      handler: this._handleFetch 
    })
  }

}

export default Authorized
